import { connect } from 'react-redux';

import DefaultPublishModal from './page_default_publish_notification.jsx';

import {
  openPageDetails
} from 'zoomforth_shared_management/action_creators/modals.js';

import pagesStore from 'zoomforth_zf/appglobals/pages.js';

const mapStateToProps = (state, { pageId }) => (
  {
    page: pagesStore.get().get(pageId)
  }
);

const mapDispatchToProps = (dispatch, { pageId }) => (
  {
    onEditVisitorAccessClick: ()=> { 
      dispatch(openPageDetails(pageId, 'access'));
    }
  }
);

const PageDefaultPublishModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultPublishModal);

export default PageDefaultPublishModal;
